import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable, startWith, Subject, Subscription } from 'rxjs';
import { selectDepartmentId } from 'src/app/shared/store/router/router.selectors';
import { SidebarService } from './sidebar.service';

@UntilDestroy()
@Injectable()
export class SidebarOpenFolderService {
  private readonly activeDepartmentId$ = inject(Store).select(selectDepartmentId);

  private readonly departmentIds$ = inject(SidebarService).departments$.pipe(
    map((entries) => entries.map((entry) => entry.id)),
  );

  private _openDepartment$: Subject<number> = new BehaviorSubject<number>(undefined);

  private subscription: Subscription;

  constructor() {
    this.departmentIds$.pipe(untilDestroyed(this), distinctUntilChanged()).subscribe((departmentIds) => {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = this.activeDepartmentId$
        .pipe(
          untilDestroyed(this),
          filter((departmentId) => departmentId !== null),
          distinctUntilChanged(),
          startWith(departmentIds[0]),
        )
        .subscribe((departmentId) => {
          this.setOpenDepartment(departmentId);
        });
    });
  }

  get openDepartment$(): Observable<number> {
    return this._openDepartment$.asObservable().pipe(distinctUntilChanged());
  }

  setOpenDepartment(departmentId: number): void {
    this._openDepartment$.next(departmentId);
  }
}
